export default __webpack_public_path__ + "static/media/ringTriangle.63634aee.svg";